interface AppConfig {
  API_URL: string
  API_ORIGIN: string
  DEBUG: boolean
}

// Esta variable será reemplazada en tiempo de compilación por webpack
declare const __DEVELOPMENT__: boolean

const config: AppConfig = {
  // Usar variable de entorno o fallback basado en modo
  API_URL:
    process.env.API_URL ||
    (__DEVELOPMENT__
      ? 'http://localhost:3000/api/v1'
      : 'https://api.flyiot.net/api/v1'),

  API_ORIGIN: '',

  // Modo debug solo en desarrollo
  DEBUG: __DEVELOPMENT__,
}

config.API_ORIGIN = new URL(config.API_URL).origin

// Definición de endpoints de la API
export const API_ENDPOINTS = {
  BASE: config.API_URL,
  BASE_ORIGIN: config.API_ORIGIN,
  AUTH: `${config.API_URL}/users/login`,
  VERIFY_TOKEN: `${config.API_URL}/users/verify-token`,
  CURRENT_USER: `${config.API_URL}/users/me`, // Asumiendo endpoint /me
  DEVICES: `${config.API_URL}/devices`,
  DEVICE_CMD: (deviceId: string) => `${config.API_URL}/cmd/${deviceId}`,
  DEVICE_HISTORY: (deviceId: string) =>
    `${config.API_URL}/history/device/${deviceId}`,
  FIRMWARES: `${config.API_URL}/firmwares`,
}

export default config
